<app-breadcrumb [title]="'Not Found'" [items]="['Not Found']" [active_item]="'Not Found'"></app-breadcrumb>
<div class="container-fluid">
	<div class="row">
		<div class="col-sm-12">
			<div class="card">
				<div class="card-header">
					<h5>NOT FOUND</h5>
					<span>Page Not Found</span>
				</div>
				<div class="card-body text-center">
					<img width="500" height="500" src="assets/images/avtar/404-not-found.webp" />
				</div>
			</div>
		</div>
	</div>
</div>
